import { type ReactElement } from 'react'
import { useConnectionLayer } from './useConnectionsLayer'
import { type Edge, type ConnectionLayerOptions } from './types'

type ConnectionLayerProps = {
  edges: Edge[]
  options?: ConnectionLayerOptions
}

export const ConnectionLayer = ({ edges, options }: ConnectionLayerProps): ReactElement => {
  const connectionsRef = useConnectionLayer(edges, options)

  return (
    <svg
      className='pointer-events-none absolute top-0 left-0 h-full w-full'
      preserveAspectRatio='none'
      ref={connectionsRef}
      style={{ zIndex: -1, opacity: options?.opacity }}
    />
  )
}
